export default "__VITE_ASSET__BdR7yeqn__"